// copied from packages/ui/src/components/FlavorFinder/components/ResultCard/index.ts
export * from "./FlavorFinderResultCard";
